export const CONSOLE_VERSION = 'sha-718e313';
